import type { DeepPartial } from '@packages/config/src/default/types';
import { makeFragmentData } from '@packages/gql/generated/shopping';
import { AplusFragmentFragmentDoc } from '@packages/gql/generated/shopping/AplusFragmentFragmentDoc';
import type {
  BasketActionsFragmentFragment,
  BasketTrackingFragmentFragment,
  LineItemFragmentFragment,
  WishlistLineItemsFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';

export const lineItemsMockData: LineItemFragmentFragment[] &
  DeepPartial<BasketTrackingFragmentFragment['lineItems']> = [
  {
    extra: {
      brand: 'LASCANA',
      category: '323',
      breadcrumbs: null,
      description: 'LASCANA Longshirt, (2er-Pack), mit breitem Bund',
      size: '32',
      variation: 'Farbe: taupe, schwarz',
      hasOldPrice: 'nein',
      promotion: '95',
      discountedTotalPrice: '39.98',
      mastersku: 'AKLBB384258862',
      mkz: '229',
      sourceShopPath: null,
    },
    id: '18dfca61-0787-4859-87e0-3749d2b33eff',
    product: {
      akl: 'AKLBB384258862',
      sku: '21212284-32-384258862',
      orderNumber: '212122',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/895237562949513e7ab9871d2ff9c79d',
      name: 'LASCANA Longshirt, (2er-Pack), mit breitem Bund',
      brand: 'LASCANA',
      powerEfficiencyFlags: null,
      variation: 'Farbe: taupe, schwarz',
      sustained: true,
      marketingFlag: null,
    },
    price: {
      amount: 1,
      currency: 'EUR',
      isStartPrice: false,
      saving: null,
      unit: 'Stk',
      uvp: null,
      value: 3998,
      valueOld: null,
      valueUnit: 1999,
      discount: null,
    },
    singlePrice: {
      amount: 3998,
      currency: 'EUR',
    },
    availability: {
      message: 'vorrätig - in 2-3 Werktagen bei dir',
      state: 'AVAILABLE',
    },
    configuration: null,
    aplus: null,
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: '8ba7aef4-6df1-4772-9e06-248def20900e',
    product: {
      akl: 'AKLBB658551249',
      sku: '6576801188-0-658551249',
      orderNumber: '65768011',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/2c97db81305786c986c295f923b73a0b',
      name: 'Bruno Banani Henkeltasche, mit Schmuckanhänger und silberfarbenen Details',
      brand: 'Bruno Banani',
      powerEfficiencyFlags: null,
      variation: 'Farbe: schwarz | Maße: B/H/T: 34 cm x 30 cm x 16 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 17990,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 8995,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 2,
    isSoldOut: false,
  },
  {
    id: '8b19a051-ff3e-43ce-936b-ff1e5b095826',
    product: {
      akl: 'AKLBB654803207',
      sku: '6819416430-XL-654803207',
      orderNumber: '68194164',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/dbd93c2b82c6fd3267ae09b11605b4f4',
      name: 'HEAT keeper Thermounterhemd »Thermo Langarm-Shirt«',
      brand: 'HEAT keeper',
      powerEfficiencyFlags: null,
      variation: 'Farbe: anthrazit-meliert | Körbchengröße: N-Gr',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: 1,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: 'Stk',
      uvp: null,
      value: 3398,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 1699,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,

    quantity: 2,
    isSoldOut: false,
  },
  {
    id: '056718cf-6552-4407-8ca8-ee29ea565f98',
    product: {
      akl: 'AKLBB670158235',
      sku: '9392481844-43-670158235',
      orderNumber: '93924818',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/01b512d34652c9607e700d91149d09c8',
      name: 'Head Wandersocken, (2 Paar), mit flacher Zehennaht',
      brand: 'Head',
      powerEfficiencyFlags: null,
      variation: 'Farbe: schwarz-rot',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: 1,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'PERCENT',
        value: 7,
      },
      unit: 'Paar',
      uvp: null,
      value: 5196,
      valueOld: 5596,
      valueUnit: 650,
      discount: null,
    },
    singlePrice: {
      amount: 1299,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 4,
    isSoldOut: false,
  },
  {
    id: 'b48337e3-dbc2-4638-b335-9f5ce7a1c424',
    product: {
      akl: 'AKLBB395212430',
      sku: '63115896-0-395212430',
      orderNumber: '631158',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/4e4e62e8dde677c4af7a5775a23d5603',
      name: 'camel active Gürteltasche »JOURNEY«, ideal für Konzert, Festival und Städtetrip',
      brand: 'camel active',
      powerEfficiencyFlags: null,
      variation: 'Farbe: schwarz | Maße: B/H/T: 29 cm x 13 cm x 7 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 2999,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 2999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: '2f28e45d-e1c8-43ca-8f44-068427512694',
    product: {
      akl: 'AKLBB494107901',
      sku: '66836380-0-494107901',
      orderNumber: '668363',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/7ed0f45c0e9743b776d15fee49d83891',
      name: 'BIOTHERM Nachtcreme »Blue Therapy Night Cream«, Anti-Aging',
      brand: 'BIOTHERM',
      powerEfficiencyFlags: null,
      variation: 'Farbe: blau | Inhalt: 50 ml',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: 1,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'PERCENT',
        value: 22,
      },
      unit: 'l',
      uvp: true,
      value: 20493,
      valueOld: 26400,
      valueUnit: 136620,
      discount: null,
    },
    singlePrice: {
      amount: 6831,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 3,
    isSoldOut: false,
  },
  {
    id: 'db425159-6fa5-4f1f-8f80-9c108803b8dc',
    product: {
      akl: 'AKLBB1145589811',
      sku: '7573255442-0-1145589811',
      orderNumber: '75732554',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/266085014ef5efe38d5d72407080c0ff',
      name: 'You2Toys Stoß-Vibrator',
      brand: 'You2Toys',
      powerEfficiencyFlags: null,
      variation: 'Farbe: schwarz',
      sustained: false,
      marketingFlag: {
        text: 'Bestpreis',
        type: 'contrast',
      },
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'PERCENT',
        value: 16,
      },
      unit: null,
      uvp: true,
      value: 41290,
      valueOld: 49500,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 8258,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 5,
    isSoldOut: false,
  },
  {
    id: 'c2ff497c-c3e7-4557-84d3-298f696bf2bf',
    product: {
      akl: 'AKLBB642578860',
      sku: '1636301365-62-642578860',
      orderNumber: '16363013',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/614c29578eca4050ff0ae872ca6c5108.jpg',
      name: '5-Pocket-Jeans, (1 tlg.)',
      brand: '',
      powerEfficiencyFlags: null,
      variation: 'Farbe: blue-stone-washed | Länge: Normalgrößen',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 29697,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 9899,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 3,
    isSoldOut: false,
  },
  {
    id: '9e623e24-eab4-4daf-823c-265f1f16e71d',
    product: {
      akl: 'AKLBB1189174290',
      sku: '6243900782-0-1189174290',
      orderNumber: '62439007',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/4f050c7f88650e3d280eca34a8fe5eb3.jpg',
      name: 'Oral B Elektrische Zahnbürste »iO Series 8N«, 1 St. Aufsteckbürsten, Magnet-Technologie',
      brand: 'Oral B',
      powerEfficiencyFlags: null,
      variation: 'Farbe: schwarz',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 48000,
      },
      unit: null,
      uvp: true,
      value: 83996,
      valueOld: 131996,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 20999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: '8642d686-d0b4-4e48-86be-897bf1d54dc9',
                  name: '48 Monate Langzeitgarantie Personal Care',
                  price: {
                    currency: 'EUR',
                    value: 2999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 4,
    isSoldOut: false,
  },
  {
    id: '774707a4-4e2c-4cc0-a043-52595263f3be',
    product: {
      akl: 'AKLBB697192246',
      sku: '7427624014-0-697192246',
      orderNumber: '74276240',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/abd82aca78557bf176519f080c52a419.jpg',
      name: 'Hanseatic Waschmaschine »HWMB814B«, HWMB814B, 8 kg, 1400 U/min',
      brand: 'Hanseatic',
      powerEfficiencyFlags: [
        {
          text: '',
          iconText: '',
          link: 'https://bilder.baur.de/i/empiriecom/640e73c3d73238d736e1838e0d2f3e0a.jpg',
          icon: 'https://bilder.baur.de/i/empiriecom/A_bis_G_B_mediumgreen',
          dataSheet: 'https://bilder.baur.de/v1/static/cc38cca7b8267fea9aa977f695c2608e',
        },
      ],
      variation: 'Farbe: weiß',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 99505,
      },
      unit: null,
      uvp: true,
      value: 174995,
      valueOld: 274500,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 34999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: 'f03567ac-6a95-4ca5-b217-9677b1bb3123',
                  name: '48 Monate Garantie für das Sortiment Waschen',
                  price: {
                    currency: 'EUR',
                    value: 5499,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'INSTALLATION',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_INSTALLATION?$serviceIcon$',
                  uuid: '3774b811-71e8-448c-976b-8666d7ce4f71',
                  name: 'Anschluss-Service für Waschmaschinen',
                  price: {
                    currency: 'EUR',
                    value: 1500,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Entsorgung',
              services: [
                {
                  serviceType: 'OLD_PRODUCT_REMOVAL',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_OLD_PRODUCT_REMOVAL?$serviceIcon$',
                  uuid: '9602abd7-363a-4f64-8aa8-ae156420279b',
                  name: 'Altgeräte-Rücknahme nach Gesetz',
                  price: {
                    currency: 'EUR',
                    value: 0,
                  },
                  included: false,
                  layerLink: null,
                  selected: true,
                  serviceCount: {
                    current: 1,
                    maximum: 6,
                  },
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 5,
    isSoldOut: false,
  },
  {
    id: 'a5c1df0c-c4a9-4984-83d5-366fa104940b',
    product: {
      akl: 'AKLBB509034829',
      sku: '2409415391-0-509034829',
      orderNumber: '24094153',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/dba08deb0fe865b3f2e70b749d950d32',
      name: 'Jockenhöfer Gruppe Wohnlandschaft »Florida«, mit Federkern, Bettfunktion und Bettkasten, inklusive 2 Kopfstützen',
      brand: 'Jockenhöfer Gruppe',
      powerEfficiencyFlags: null,
      variation:
        'Bezug: Luxus-Microfaser ALCATOP-Struktur | Farbe: anthrazit | Maße: B/H/T: 337 cm x 69 cm x 180 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 90000,
      },
      unit: null,
      uvp: true,
      value: 239998,
      valueOld: 329998,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 119999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: 'bcaada6f-abf4-4bf1-bee0-f3e9b3b9d85f',
                  name: '48 Monate Garantie für Möbel',
                  price: {
                    currency: 'EUR',
                    value: 7999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'ASSEMBLE',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_ASSEMBLE?$serviceIcon$',
                  uuid: 'f1e3dd5f-7b3e-4b34-a844-f571a45156ca',
                  name: 'Aufbau von Polstermöbel',
                  price: {
                    currency: 'EUR',
                    value: 9500,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
                {
                  serviceType: 'CLEANUP_LIVING',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_CLEANUP_LIVING?$serviceIcon$',
                  uuid: '900e538e-2fd7-4f05-ae06-0d3004840f3c',
                  name: 'Altmöbelmitnahme',
                  price: {
                    currency: 'EUR',
                    value: 15000,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Kostenlos für Dich',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: '3fd92d72-ecc8-4299-9739-7cc47a2edf7b',
                  name: '36 Monate Langzeitgarantie für Smartphones (inklusive)',
                  price: {
                    value: 0,
                    currency: 'EUR',
                  },
                  included: true,
                  layerLink: null,
                  selected: true,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 2,
    isSoldOut: false,
  },
  {
    id: 'd0f57be3-05b6-4e0b-993f-a2611e85c5df',
    product: {
      akl: 'AKLBB454736086',
      sku: '3194454871-0-454736086',
      orderNumber: '31944548',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/bd500a1454f83b3359451637b752b874.jpg',
      name: 'Mr. Couch Ecksofa »Nikita«, wahlweise mit Kaltschaum (140kg Belastung/Sitz), Bettfunktion',
      brand: 'Mr. Couch',
      powerEfficiencyFlags: null,
      variation:
        'Bezug: Microfaser PRIMABELLE®-Struktur | Farbe: anthrazit/dunkelgrau | Ausführung: Ottomane links | Funktion: belastbar bis 100kg-mit RGB-LED-Beleuchtung | Maße: B/H/T: 240 cm x 86 cm x 190 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 72402,
      },
      unit: null,
      uvp: true,
      value: 199998,
      valueOld: 272400,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 99999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Kostenlos für Dich',
              services: [
                {
                  serviceType: 'ASSEMBLE',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_ASSEMBLE?$serviceIcon$',
                  uuid: '5d8f1624-6eab-427e-a4e0-dbefcd439d38',
                  name: 'Kostenloser Aufbauservice  (Kleinstmontage)',
                  price: {
                    currency: 'EUR',
                    value: 0,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'CLEANUP_LIVING',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_CLEANUP_LIVING?$serviceIcon$',
                  uuid: 'b8d7a10b-a8bd-491d-914b-4766b03d3398',
                  name: 'Altmöbelmitnahme',
                  price: {
                    currency: 'EUR',
                    value: 11000,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Entsorgung',
              services: [
                {
                  serviceType: 'OLD_PRODUCT_REMOVAL',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_OLD_PRODUCT_REMOVAL?$serviceIcon$',
                  uuid: '9602abd7-363a-4f64-8aa8-ae156420279b',
                  name: 'Altgeräte-Rücknahme nach Gesetz',
                  price: {
                    currency: 'EUR',
                    value: 0,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 2,
    isSoldOut: false,
  },
  {
    id: '7917dee1-0735-4c04-a178-86e6d97f2d13',
    product: {
      akl: 'AKLBB1032807373',
      sku: '2659893571-0-1032807373',
      orderNumber: '26598935',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/13f1726a4eeea786a720101953637e58',
      name: 'Places of Style Ecksofa »Costello«, incl. Sitztiefenverstellung und Armlehnfunktion, incl. 2 Nierenkissen',
      brand: 'PLACES OF STYLE',
      powerEfficiencyFlags: null,
      variation:
        'Bezug: Struktur flausch | Farbe: silber | Ausführung: Recamiere links | Funktion: ohne Bettfunktion-ohne Bettkasten | Maße: B/H/T: 301 cm x 89 cm x 176 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 119901,
      },
      unit: null,
      uvp: true,
      value: 154999,
      valueOld: 274900,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 154999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: 'bcaada6f-abf4-4bf1-bee0-f3e9b3b9d85f',
                  name: '48 Monate Garantie für Möbel',
                  price: {
                    currency: 'EUR',
                    value: 9999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'ASSEMBLE',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_ASSEMBLE?$serviceIcon$',
                  uuid: 'f1e3dd5f-7b3e-4b34-a844-f571a45156ca',
                  name: 'Aufbau von Polstermöbel',
                  price: {
                    currency: 'EUR',
                    value: 9500,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
                {
                  serviceType: 'CLEANUP_LIVING',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_CLEANUP_LIVING?$serviceIcon$',
                  uuid: 'b8d7a10b-a8bd-491d-914b-4766b03d3398',
                  name: 'Altmöbelmitnahme',
                  price: {
                    currency: 'EUR',
                    value: 11000,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: 'bb056b4c-18a1-4fbd-ad45-634bd662670c',
    product: {
      akl: 'AKLBB560522715',
      sku: '20879580-0-560522715',
      orderNumber: '208795',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/1216c6f461ba9b12ea1d282301914a22',
      name: 'Helvetia Wohnwand »Larona«, (Set, 4 St.)',
      brand: 'Helvetia',
      powerEfficiencyFlags: null,
      variation: 'Farbe: Sibiu weiß/eichefarben sägerau dunkel',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 92400,
      },
      unit: null,
      uvp: true,
      value: 119998,
      valueOld: 212398,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 59999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: 'bcaada6f-abf4-4bf1-bee0-f3e9b3b9d85f',
                  name: '48 Monate Garantie für Möbel',
                  price: {
                    currency: 'EUR',
                    value: 4999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'ASSEMBLE',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_ASSEMBLE?$serviceIcon$',
                  uuid: '3e53639d-f907-4294-8f05-ef444083a470',
                  name: 'Aufbau von Wohnwänden',
                  price: {
                    currency: 'EUR',
                    value: 29900,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 2,
    isSoldOut: false,
  },
  {
    id: '9d4b0d52-85b1-4404-9838-bd16f84ed184',
    product: {
      akl: 'AKLBB564437966',
      sku: '69422391-0-564437966',
      orderNumber: '694223',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/5922b96be2061cfed736a4f4f668bdd1.jpg',
      name: 'Helvetia Wohnwand »Toledo«, (Set, 5 St.)',
      brand: 'Helvetia',
      powerEfficiencyFlags: null,
      variation: 'Farbe: weiß matt/weiß HG/eichefarben San Remo',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 85400,
      },
      unit: null,
      uvp: true,
      value: 99999,
      valueOld: 185399,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 99999,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: 'bcaada6f-abf4-4bf1-bee0-f3e9b3b9d85f',
                  name: '48 Monate Garantie für Möbel',
                  price: {
                    currency: 'EUR',
                    value: 7999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Einfach bequem - wir kümmern uns',
              services: [
                {
                  serviceType: 'ASSEMBLE',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_ASSEMBLE?$serviceIcon$',
                  uuid: '3e53639d-f907-4294-8f05-ef444083a470',
                  name: 'Aufbau von Wohnwänden',
                  price: {
                    currency: 'EUR',
                    value: 35900,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: 'bc05d7eb-90ea-4a50-b1a6-3bd1f849',
    product: {
      akl: 'AKLBB1295476898',
      sku: '8415495271-0-1295476898',
      orderNumber: '84154952',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/b9bf832709ecb4363748209dd42f796e.jpg',
      name: 'KRAUSE Schiebeleiter »Corda Seilzugleiter«, 2x16 Sprossen',
      brand: 'KRAUSE',
      powerEfficiencyFlags: null,
      variation: 'Farbe: aluminiumfarben | Maße: B/H/L: 113 cm x 665 cm x 450 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'PERCENT',
        value: 7,
      },
      unit: null,
      uvp: true,
      value: 46203,
      valueOld: 50200,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 46203,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: '929bed79-ec9a-4d80-a94a-166cbea7fc8f',
    product: {
      akl: 'AKLBB501777021',
      sku: '19305695-5-501777021',
      orderNumber: '193056',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/4368fb6fcdde76d10c5f2ebc264cc2e0.jpg',
      name: 'Liedeco Seitenzugrollo »Uni«, verdunkelnd, energiesparend, mit Bohren',
      brand: 'Liedeco',
      powerEfficiencyFlags: null,
      variation: 'Farbe: dunkelgrau | Breite: 112 cm',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 27460,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 5492,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 5,
    isSoldOut: false,
  },
  {
    id: '80bc5b95-2e86-4454-b535-b72c36fefca5',
    product: {
      akl: 'AKLBB1225808976',
      sku: '8213645623-0-1225808976',
      orderNumber: '82136456',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/99fdd995e3195ae43f5c67f859f6dcd8.jpg',
      name: 'Wolff Grillkota »9 de luxe«, mit Sauna-Anbau und roten Schindeln',
      brand: 'Wolff',
      powerEfficiencyFlags: null,
      variation: 'Farbe: natur | Fußboden: Fußboden im Gartenhaus | Dacheindeckung: Dachschindeln',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 113959,
      },
      unit: null,
      uvp: true,
      value: 1055041,
      valueOld: 1169000,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 1055041,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: '2235a9d9-f6c5-4f70-a64f-1828be319afd',
    product: {
      akl: 'AKLBB1611550146',
      sku: '8623002342-0-1611550146',
      orderNumber: '86230023',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/3f62bcd992a25729c374572fb9d84e3d.jpg',
      name: 'Samsung Kühl-/Gefrierkombination, RL36T600CSA, 193,5 cm hoch, 59,5 cm breit',
      brand: 'Samsung',
      powerEfficiencyFlags: [
        {
          text: '',
          iconText: '',
          link: 'https://bilder.baur.de/i/empiriecom/f88b0d169f01928739c7128d53fb998a.jpg',
          icon: 'https://bilder.baur.de/i/empiriecom/A_bis_G_C_lightgreen',
          dataSheet: 'https://bilder.baur.de/v1/static/c780eff522c786984f15c07428d0182d',
        },
      ],
      variation: 'Farbe: edelstahl optik',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'CURRENCY',
        value: 45000,
      },
      unit: null,
      uvp: true,
      value: 59900,
      valueOld: 104900,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 59900,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: {
      ...makeFragmentData(
        {
          clusters: [
            {
              label: 'Extra Schutz? Sichere Dich ab',
              services: [
                {
                  serviceType: 'LONG_TERM_WARRANTY',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_LONG_TERM_WARRANTY?$serviceIcon$',
                  uuid: '0e671e97-a915-4d1a-84da-71ce53661b6f',
                  name: '48 Monate Garantie für Kühlkombinationen',
                  price: {
                    currency: 'EUR',
                    value: 6999,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
            {
              label: 'Entsorgung',
              services: [
                {
                  serviceType: 'OLD_PRODUCT_REMOVAL',
                  serviceIcon:
                    'https://bilder.baur.de/i/empiriecom/service_baurde_OLD_PRODUCT_REMOVAL?$serviceIcon$',
                  uuid: 'b7904fc6-2b79-4542-9c0d-f0f5e318076b',
                  name: 'Altgeräte-Rücknahme nach Gesetz',
                  price: {
                    currency: 'EUR',
                    value: 0,
                  },
                  included: false,
                  layerLink: null,
                  selected: false,
                  serviceCount: null,
                },
              ],
            },
          ],
        },
        AplusFragmentFragmentDoc,
      ),
    },
    quantity: 1,
    isSoldOut: false,
  },
  {
    id: 'f0f8f6cf-933c-48c9-8171-16d1096261e2',
    product: {
      akl: 'AKLBB1642133708',
      sku: '67857077-0-1642133708',
      orderNumber: '678570',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/80af4557d0ca410879b4d44cf4d43a0b',
      name: 'Firetti Kette mit Anhänger »Lebensbaum/Baum des Lebens«',
      brand: 'Firetti',
      powerEfficiencyFlags: null,
      variation: 'Farbe: silberfarben | Material: Silber 925 (Sterlingsilber)',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: {
        type: 'PERCENT',
        value: 9,
      },
      unit: null,
      uvp: true,
      value: 15880,
      valueOld: 17640,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 3176,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 5,
    isSoldOut: false,
  },
  {
    id: 'f2af0b2f-21f7-4324-8131-9699ea80b315',
    product: {
      akl: 'AKLBB1215240276',
      sku: '1463745597-M-1215240276',
      orderNumber: '14637455',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/61a5ff903810209375d68ed1b7ccd7fe.jpg',
      name: 'LASCANA Taillengürtel, mit modischer Schließe und elatischem Band',
      brand: 'LASCANA',
      powerEfficiencyFlags: null,
      variation: 'Farbe: silberfarben | Größe: M',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 6897,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 2299,
      currency: 'EUR',
    },
    availability: {
      message: 'Abfrage der Verfügbarkeit z.Zt. nicht möglich',
      state: 'UNSELECTED',
    },
    configuration: null,
    aplus: null,
    quantity: 3,
    isSoldOut: false,
  },
  {
    id: '5a6427ba-8523-421b-9b8d-ee0df0907b32',
    product: {
      akl: 'AKLBB1281583242',
      sku: '2440923416-0-1281583242',
      orderNumber: '24409234',
      imageUrl: 'https://bilder.baur.de/i/empiriecom/650ac0db70cb9b745470b1f050eeffbe.jpg',
      name: 'Coopertires Winterreifen »Discoverer Winter XL«, (1 St.), 225/55 R18 102V',
      brand: 'Coopertires',
      powerEfficiencyFlags: [
        {
          text: 'Kraftstoffeffizienz',
          iconText: 'C',
          link: 'https://bilder.baur.de/i/empiriecom/9f9f0fdb42c4c581e41581b5d028179a.jpg',
          icon: 'https://bilder.baur.de/i/empiriecom/EEK_Kraftstoffeffizienzklasse',
          dataSheet: 'https://bilder.baur.de/v1/static/54e515092e61c2d4be1bfe7d44b289ac',
        },
        {
          text: 'Nasshaftung',
          iconText: 'C',
          link: 'https://bilder.baur.de/i/empiriecom/9f9f0fdb42c4c581e41581b5d028179a.jpg',
          icon: 'https://bilder.baur.de/i/empiriecom/EEK_Nasshaftungsklasse',
          dataSheet: 'https://bilder.baur.de/v1/static/54e515092e61c2d4be1bfe7d44b289ac',
        },
        {
          text: 'Rollgeraeusch',
          iconText: 'B | 71 dB',
          link: 'https://bilder.baur.de/i/empiriecom/9f9f0fdb42c4c581e41581b5d028179a.jpg',
          icon: 'https://bilder.baur.de/i/empiriecom/EEK_Rollgeraeusch',
          dataSheet: 'https://bilder.baur.de/v1/static/54e515092e61c2d4be1bfe7d44b289ac',
        },
      ],
      variation: 'Farbe: schwarz | Reifengröße: 225 mm/55 % R 18 " 102V',
      sustained: false,
      marketingFlag: null,
    },
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: null,
      saving: null,
      unit: null,
      uvp: null,
      value: 98796,
      valueOld: null,
      valueUnit: null,
      discount: null,
    },
    singlePrice: {
      amount: 24699,
      currency: 'EUR',
    },
    availability: {
      message: 'nicht bestellbar',
      state: 'NOT_AVAILABLE',
    },
    configuration: null,
    aplus: null,
    quantity: 4,
    isSoldOut: true,
  },
];
export const wishlistLineItemsMockData: Array<WishlistLineItemsFragmentFragment> &
  Array<BasketActionsFragmentFragment> = [
  {
    sku: '3527241360-28-1179233400',
    akl: 'AKLBB1179233400',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/8d5b40c7089befe0735650bc43f012d0.jpg',
    name: 'GANG Relax-fit-Jeans »94Gerda«',
    isSoldOut: false,
    deliveryMessage: 'vorrätig - in 2-3 Werktagen bei dir',
    deliveryTextColor: 'Success',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: {
        type: 'Percent',
        value: 19,
      },
      unit: null,
      uvp: true,
      value: 9599,
      valueOld: 11995,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: blue used | Länge: N-Gr | Größe: 28 (36) | Relaxed fit Jeans "94Gerda" von GANG | Wohlfühlfaktor durch Stretchanteil | Relaxed fit mit etwas niedriger Leibhöhe | Fällt groß aus bitte eine Größe kleiner bestellen | Trendy gestylt zu Wedges, Pumps oder Ankle Boots',
    powerEfficiency: null,
    extra: {
      brand: 'GANG',
    },
  },
  {
    sku: '6227773383-0-1393776512',
    akl: 'AKLBB1393776512',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/478caa4007cfbe18f84738e7fc677b4b.jpg',
    name: 'KONIFERA Pavillon »Aruba«, (Set)',
    isSoldOut: false,
    deliveryMessage: 'kommt in einer Woche',
    deliveryTextColor: 'Success',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: null,
      unit: null,
      uvp: false,
      value: 57500,
      valueOld: null,
      valueUnit: null,
    },
    unspecified: true,
    variation:
      'Farbe: beige | Maße: B/H/T: 300 cm x 270 cm x 400 cm | Hohe Standfestigkeit, 76 mm Pfostenstärke | Aus pulverbeschichtetem Aluminium | Mit 6 mm starken Polycarbonat-Doppelstegplatten | Inkl. Seitenteile in beige | Schutz vor Sonne, Regen und leichtem Schnee',
    powerEfficiency: null,
    extra: {
      brand: 'KONIFERA',
    },
  },
  {
    sku: '7427624028-0-697192246',
    akl: 'AKLBB697192246',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/abd82aca78557bf176519f080c52a419.jpg',
    name: 'Hanseatic Waschmaschine »HWMB814B«, HWMB814B, 8 kg, 1400 U/min',
    isSoldOut: false,
    deliveryMessage: 'kommt in zwei Wochen',
    deliveryTextColor: 'Warning',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: {
        type: 'Currency',
        value: 20901,
      },
      unit: null,
      uvp: true,
      value: 33999,
      valueOld: 54900,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: weiß | Luftschallemission 76 dB(A) | Invertermotor | Schnellwaschprogramm - 2kg in 15 Minuten | Startzeitvorwahl | Programmspeicher',
    powerEfficiency: [
      {
        text: null,
        iconText: null,
        link: 'https://bilder.baur.de/i/empiriecom/640e73c3d73238d736e1838e0d2f3e0a.jpg',
        icon: 'https://bilder.baur.de/i/empiriecom/A_bis_G_B_mediumgreen',
        dataSheet: 'https://bilder.baur.de/v1/static/cc38cca7b8267fea9aa977f695c2608e',
      },
    ],
    extra: {
      brand: 'Hanseatic',
    },
  },
  {
    sku: '6576801192-0-658551249',
    akl: 'AKLBB658551249',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/2c97db81305786c986c295f923b73a0b',
    name: 'Bruno Banani Henkeltasche',
    isSoldOut: false,
    deliveryMessage: 'vorrätig - in 2-3 Werktagen bei dir',
    deliveryTextColor: 'Success',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: null,
      unit: null,
      uvp: false,
      value: 8995,
      valueOld: null,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: schwarz | Maße: B/H/T: 34 cm x 30 cm x 16 cm | Aus schickem Lederimitat | Gr. ca. B/H/T 34/30/16 cm | 3 Hauptfächer | Reißverschluss-Innenfach | Verstellbarer, abnehmbarer Umhängeriemen',
    powerEfficiency: null,
    extra: {
      brand: 'Bruno Banani',
    },
  },
  {
    sku: '21212270-32-384258862',
    akl: 'AKLBB384258862',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/895237562949513e7ab9871d2ff9c79d',
    name: 'LASCANA Longshirt, (2er-Pack)',
    isSoldOut: false,
    deliveryMessage: 'vorrätig - in 2-3 Werktagen bei dir',
    deliveryTextColor: 'Success',
    price: {
      amount: 1,
      currency: 'EUR',
      isStartPrice: false,
      saving: null,
      unit: 'Stk',
      uvp: false,
      value: 3998,
      valueOld: null,
      valueUnit: 1999,
    },
    unspecified: false,
    variation:
      'Farbe: taupe, schwarz | Größe: 32/34 | Lascana Shirt im 2er-Sparpack | Mit weitem Ausschnitt und angeschnittenen Ärmel | Mit breitem Bund am Saum für zwei Tragevarianten - lang oder kürzer geschoppt | Aus weich fließender Viskose-Elasthan-Qualität',
    powerEfficiency: null,
    extra: {
      brand: 'LASCANA',
    },
  },
  {
    sku: '3054342272-38-1659345140',
    akl: 'AKLBB1659345140',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/ca84b38672adf99ce297d2c4a2832a04.jpg',
    name: 'Rieker Sneaker',
    isSoldOut: true,
    deliveryMessage: 'ausverkauft',
    deliveryTextColor: 'Error',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: {
        type: 'Percent',
        value: 19,
      },
      unit: null,
      uvp: true,
      value: 5597,
      valueOld: 6995,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: weiß | Größe: 38 | Mit Schnürung und Reißverschluss außen | Aus beschichtetem Leder | Weiche Textilinnensohle | Monochromer Look | Sportive Laufsohle',
    powerEfficiency: null,
    extra: {
      brand: 'Rieker',
    },
  },
  {
    sku: '3685793126-35-1438791538',
    akl: 'AKLBB1438791538',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/7343490e4fa2b3e3d7d5921c5dd89c6f.jpg',
    name: 'Rieker Plateausneaker',
    isSoldOut: true,
    deliveryMessage: 'ausverkauft',
    deliveryTextColor: 'Error',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: null,
      unit: null,
      uvp: false,
      value: 6495,
      valueOld: null,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: weiß | Größe: 35 | Sportiver Sneaker zum Schnüren | Aus weichem Lederimitat | Mit softer Lederinnensohle | 3,5 cm Plateausohle | Mit silberfarbenen Kontrastdetails',
    powerEfficiency: null,
    extra: {
      brand: 'Rieker',
    },
  },
  {
    sku: '5550364380-0-1772596240',
    akl: 'AKLBB1772596240',
    imageUrl: 'https://bilder.baur.de/i/empiriecom/7d05f31bb62af201e094607fa5ffb2b1.jpg',
    name: 'KONIFERA Pavillon »Aruba 2.0«',
    isSoldOut: false,
    deliveryMessage: 'kommt in einer Woche',
    deliveryTextColor: 'Success',
    price: {
      amount: null,
      currency: 'EUR',
      isStartPrice: false,
      saving: {
        type: 'Currency',
        value: 29901,
      },
      unit: null,
      uvp: true,
      value: 49999,
      valueOld: 79900,
      valueUnit: null,
    },
    unspecified: false,
    variation:
      'Farbe: beige | Maße: B/H/T: 300 cm x 265 cm x 300 cm | Einfache Montage und ideal für verschiedene Anlässe | Standfestes, pulverbeschichtetes Gestell aus Aluminium, Pfosten 76x76 mm | Lichtdurchlässiges Dach mit 6 mm starken Platten aus Polycarbonat | Inklusive 4 Seitenteilen aus Polyester (180 g/m²) | Schutz vor Sonne, Regen und leichtem Schnee',
    powerEfficiency: null,
    extra: {
      brand: 'KONIFERA',
    },
  },
];
